import React from 'react';
import { Handle, Position } from '@xyflow/react';

function NSGNode({ data, selected }) {
  return (
    <div
      className={`relative rounded-lg border-2 p-3 transition-colors ${
        selected
          ? 'border-red-500 bg-red-50/70 dark:bg-red-900/30'
          : 'border-red-300 bg-red-50/40 dark:bg-red-900/20'
      }`}
      style={{ width: 220, height: 120 }}
    >
      <Handle type="target" position={Position.Top} className="!bg-red-500" />
      <div className="mb-1 flex items-center gap-2">
        <svg className="h-4 w-4 text-red-600 dark:text-red-400 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
        <span className="text-sm font-semibold text-red-900 dark:text-red-100 truncate">{data.name}</span>
      </div>
      {data.securityRules && (
        <span className="inline-block bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200 text-xs font-mono px-2 py-0.5 rounded">
          {data.securityRules.split('\n').length} rule(s)
        </span>
      )}
      <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Network Security Group</div>
      <Handle type="source" position={Position.Bottom} className="!bg-red-500" />
    </div>
  );
}

export default NSGNode;
